export default {
  // ========== Buttons and actions ==========
  evaluations: 'Evaluations',

  // ========== AI Reports ==========
  aiActionsButton: 'AI',
  pertinenceReportTitle: 'Comparison of the {entity}',
  pertinenceButtonText: 'Comparison of the {entity}',
  pertinenceButtonTooltip: 'Analyze national and international comparison of the {entity} with AI',
  pedagogicalReportTitle: 'Pedagogical Evaluation of the {entity}',
  pedagogicalButtonText: 'Pedagogical Evaluation of the {entity}',
  pedagogicalButtonTooltip: 'Pedagogically evaluate the {entity} from the evolutionary approach and structural coherence with AI',

  // ========== Document downloads ==========
  formatCreationPlanAndMatter: 'Plan and Subject Creation Format',
  valuationReport: 'Valuation Report',
  mattersReport: 'Report of',
  outputFormat: 'Output format of',

  // ========== File generation ==========
  generatingWord: 'Generating Word...',

  // ========== States and changes ==========
  changeStateOf: 'Change the state of the',

  // ========== EgressProfile Component ==========
  notApply: 'Not Apply.',
  introduce: 'Enter the',
  duration: 'Duration',
  durationOf: 'Duration of the',
  yearOfEntry: 'Year of entry into force',
  wording: 'Wording',
  alreadyInUse: 'is already being used.',
  enterValidYear: 'Enter a valid year',
  edit: 'Edit the',
  write: 'write',
  selectOneOrMultiple: 'Select one or multiple',
  ifDefaultSelected: 'If default is selected, the descriptor statement will be enabled in other',
  noToShow: 'to show',
  whenCancelingDuration: 'When canceling, the duration of the {entity} will return to its original state.',
  cancel: 'Cancel',
  applyChanges: 'Apply changes',
  attachments: 'Attachments',

  // ========== Methods - Confirmation messages ==========
  sureDeleteDescriptiveTitle: 'Are you sure you want to delete the descriptive title?',
  actionIrreversibleDeleteObjects: 'This action cannot be undone and will delete the objects referenced below.',
  title: 'Title',
  content: 'content',
  sureDeleteDescriptiveTitleContent: 'Are you sure you want to delete the content of the descriptive title?',
  actionIrreversibleAffectOthers: 'This action cannot be undone and may affect other',
  sureDeleteAssociation: 'Are you sure you want to delete the association of this instance of',
  inThe: 'in the',
  cannotBeEmpty: 'The {entity} cannot be empty.',
  mustDefineNumericDuration: 'You must define a Duration quantity with a numeric value.',

  // ========== EgressProfileFileView Component ==========
  addAttachment: 'Add Attachment',
  files: 'Files',
  deleteAttachment: 'Delete Attachment',
  noAttachmentsToShow: 'No attachments to show.',
  selectWordFileOrDrag: 'Select a Word file(.docx) or drag it here...',
  fileSizeExceeded: 'The file cannot exceed {size} in size.',
  invalidWordFile: 'Not a valid Word(.docx) file.',
  uploadingFile: 'Uploading file...',
  pleaseWaitWhileUploading: 'Please wait while the file is being uploaded.',
  problemUploadingFile: 'There was a problem uploading the file.',
  sureDeleteAttachment: 'Are you sure you want to delete the attachment?',
}
